import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import {
  PoPageChangePasswordComponent,
  PoPageChangePasswordModule,
  PoPageChangePasswordRequirement
} from '@po-ui/ng-templates';
import { PoNotificationService, PoPageModule } from '@po-ui/ng-components';

import { LoginService } from '../../core/services/login.service';
import { ThemeService } from '../../core/services/theme.service';

interface PoChangePasswordSubmit {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

@Component({
  selector: 'app-trocar-senha',
  standalone: true,
  imports: [CommonModule, PoPageChangePasswordModule, PoPageModule],
  templateUrl: './trocar-senha.html',
  styleUrls: ['./trocar-senha.css']
})
export class TrocarSenhaComponent {

  @ViewChild(PoPageChangePasswordComponent, { static: true })
  pageChangePassword!: PoPageChangePasswordComponent;

  readonly logoUrl$: Observable<string>;
  //readonly secondaryLogoUrl$: Observable<string>;

  readonly urlBack = '/notas-list';
  readonly urlHome = '/login';

  readonly requirements: Array<PoPageChangePasswordRequirement> = [
    {
      requirement: 'Minimo de 8 caracteres',
      status: (newPassword: string) => !!newPassword && newPassword.length >= 8
    },
    {
      requirement: 'Ao menos uma letra',
      status: (newPassword: string) => !!newPassword && /[A-Za-z]/.test(newPassword)
    },
    {
      requirement: 'Ao menos um numero',
      status: (newPassword: string) => !!newPassword && /\d/.test(newPassword)
    },
    {
      requirement: 'Nova senha diferente da atual',
      status: (newPassword: string) => {
        const current = this.pageChangePassword?.currentPassword ?? '';
        return !!newPassword && newPassword !== current;
      }
    }
  ];

  constructor(
    private loginService: LoginService,
    private themeService: ThemeService,
    private notif: PoNotificationService,
    private router: Router
  ) {
    this.logoUrl$ = this.themeService.logo$;
    //this.secondaryLogoUrl$ = this.themeService.secondaryLogo$;
  }

  onSubmit(event: PoChangePasswordSubmit): void {
    const oldPassword = event?.currentPassword ?? '';
    const newPassword = event?.newPassword ?? '';
    const confirmPassword = event?.confirmPassword ?? '';

    if (!oldPassword) {
      this.notif.warning({ message: 'Informe a senha atual.' });
      return;
    }
    if (!newPassword || newPassword.length < 8) {
      this.notif.warning({ message: 'A nova senha deve ter no minimo 8 caracteres.' });
      return;
    }
    if (newPassword === oldPassword) {
      this.notif.warning({ message: 'A nova senha deve ser diferente da atual.' });
      return;
    }

    this.loginService.changePassword(oldPassword, newPassword)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.loginService.logout(false);
          this.pageChangePassword.openConfirmation();
        },
        error: (err: HttpErrorResponse) => {
          this.notif.error({ message: this.buildErrorMessage(err) });
        }
      });
  }

  private buildErrorMessage(err: HttpErrorResponse | unknown): string {
    const httpErr = err as HttpErrorResponse;
    const status = httpErr?.status;
    const backendMsg = httpErr?.error?.message;

    if (status === 401 || status === 400) {
      return backendMsg || 'Senha atual invalida. Verifique e tente novamente.';
    }
    if (status === 0) {
      return 'Nao foi possivel conectar ao servidor. Verifique sua conexao.';
    }
    return backendMsg || 'Nao foi possivel alterar a senha. Tente novamente.';
  }
}
